module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_50000_100000.d5cb6f53.png";